import React from 'react';
import PortfolioSection from '../components/sections/Portfolio';

const Portfolio = () => {
  return (
    <>
      <div className="page-title">
        <div className="container">
          <div className="title-wrapper">
            <h1>Our Portfolio</h1>
            <p>Web platforms, mobile apps, cloud migrations, and integrations we've delivered</p>
          </div>
        </div>
      </div>
      <PortfolioSection />
    </>
  );
};

export default Portfolio;
